import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, ShieldCheck } from 'lucide-react';
export function ClosingSection() {
  const scrollToCTA = () => {
    const cta = document.getElementById('cta-section');
    if (cta) cta.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-8 md:py-14 px-4 md:px-6 text-center border-t border-[var(--border-subtle)]" style={{
    backgroundColor: 'var(--bg-deep)'
  }} data-id="element-89">
      <div className="max-w-[680px] mx-auto space-y-3 md:space-y-5" data-id="element-90">
        <h2 className="text-xl md:text-3xl font-serif text-[var(--text-heading)] leading-snug" data-id="element-91">
          Ahora mismo, tienes dos opciones:
        </h2>

        <div className="space-y-3 text-base md:text-lg text-[var(--text-muted)] font-light text-left max-w-lg mx-auto bg-[var(--bg-card)] p-4 md:p-6 rounded-xl border border-[var(--border-subtle)]" data-id="element-92">
          <p data-id="element-93">
            <strong className="text-[var(--text-heading)]" data-id="element-94">Opción A:</strong>{' '}
            Cerrar esta página y seguir viviendo con miedo a la deportación.
          </p>
          <div className="w-full h-px bg-[var(--border-subtle)]" data-id="element-95"></div>
          <p data-id="element-96">
            <strong className="text-[var(--accent)]" data-id="element-97">Opción B:</strong>{' '}
            Descargar tu Plan B en 2 minutos y empezar tu camino a la libertad
            legal.
          </p>
        </div>

        <p className="text-[var(--text-primary)] font-serif italic text-lg md:text-xl pt-2" data-id="element-98">
          Tu residencia legal está a un clic de distancia. 🛂
        </p>

        <div className="pt-2 space-y-2" data-id="element-99">
          <motion.button onClick={scrollToCTA} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center gap-2 px-8 py-4 md:py-5 bg-gradient-to-r from-[var(--accent)] to-[var(--accent-hover)] text-[#faf7f2] font-extrabold text-sm rounded-lg shadow-md uppercase tracking-wide w-full md:w-auto justify-center whitespace-nowrap" data-id="element-100">
            <Lock className="w-4 h-4 flex-shrink-0" data-id="element-101" />
            ACTIVAR MI PLAN B — $6.95
          </motion.button>

          <div className="flex items-center justify-center gap-3 text-[10px] text-[var(--text-muted)] mt-2 flex-wrap" data-id="element-102">
            <span className="flex items-center gap-1" data-id="element-103">
              <Lock className="w-3 h-3" data-id="element-104" /> Pago Seguro
            </span>
            <span className="opacity-30" data-id="element-105">|</span>
            <span className="flex items-center gap-1" data-id="element-106">
              <Zap className="w-3 h-3" data-id="element-107" /> Inmediata
            </span>
            <span className="opacity-30" data-id="element-108">|</span>
            <span className="flex items-center gap-1" data-id="element-109">
              <ShieldCheck className="w-3 h-3" data-id="element-110" /> Garantía 30 días
            </span>
          </div>
        </div>
      </div>
    </section>;
}